<template>
  <div class="check-users-item-operation" :style="itemStyle" @click="addMember">
    <span class="operation">+</span>
    <span>添加</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CheckUserItemAdd',
  components: {  },
  props: {
    itemStyle: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      imTeamMemberAddVisible: state => state.imTeamMemberAddVisible
    })
  },
  watch: {
  },
  data () {
    return {
    }
  },
  methods: {
    addMember () {
      this.$store.dispatch('changeImTeamMemberAddVisibleAction', !this.imTeamMemberAddVisible)
    }
  }
}
</script>

<style lang="stylus" scoped>
.check-users-item-operation {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  margin-bottom: 10px;
  cursor: pointer;
}
.operation {
  width: 28px;
  height: 28px;
  line-height: 28px
  font-size: 20px;
  text-align: center;
  border: 1px dashed;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/team/CheckUserItemAdd.vue